import "./styles.less";

import React, { FC } from "react";
import { Skeleton, Typography } from "antd";

export interface TitleProps {
	title: string;
	level?: 1 | 2 | 3 | 4 | 5;
	limitLength?: number;
	hideInformation?: boolean;
	loading?: boolean;
}

export const Title: FC<TitleProps> = ({
	title,
	level = 1,
	limitLength = 1,
	hideInformation = false,
	loading = false,
}) => {
	if (loading) return <TitleSkeleton />;

	const ellipsis = hideInformation ? { rows: limitLength } : false;

	return (
		<Typography.Title
			level={level}
			ellipsis={ellipsis}
			className="property-title"
			title={title}>
			{title}
		</Typography.Title>
	);
};

export const TitleSkeleton = () => {
	return <Skeleton title paragraph={false} className="title-skeleton" />;
};
